let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7TFUJ")).then(() => parcelRequire('c0Gds'));